import React from 'react';

import { DCBSms } from '@pages/DCBSms';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { hlrlookupRoutes } from '@app/routing/routes/hlrlookup-routes';
import { remainingRoutes } from '@app/routing/routes/remaining-routes';
import { MainB2BLayout } from '@features/b2b-contact-form';
import { HRLLookupBanner } from '@shared/config/constants/modules/banners';
import { smsInstantRedirectConfig } from '@shared/config/sms-instant-redirect-config';

const NotFound = React.lazy(() =>
  import('@pages/NotFoundPage').then((module) => ({ default: module.NotFoundPage }))
);
const DCB = React.lazy(() => import('@pages/DCB').then((module) => ({ default: module.DCB })));
const AppDownload = React.lazy(() =>
  import('@pages/AppDownload').then((module) => ({ default: module.AppDownload }))
);

const RoutesConfigurations = React.lazy(() => import('@app/routing/RoutesConfigurations'));

const Routes = () => {
  return (
    <section className="page-section" style={{ minHeight: '100vh' }}>
      <Switch>
        <Route exact path="/appdownload/:token" component={AppDownload} />

        {hlrlookupRoutes.map((route) => (
          <Route
            key={route.path}
            exact
            path={route.path}
            render={(props: RouteComponentProps) => (
              <DCB
                {...(props as any)}
                apiSource={route.apiSource}
                phoneFormConfig={{
                  renderOperator: false,
                  telInput: true,
                  isHlrlookup: true,
                  ...route?.phoneFormConfig,
                }}
                bannerConfig={route?.bannerConfig || HRLLookupBanner}
              />
            )}
          />
        ))}

        {remainingRoutes.map((route) => (
          <Route
            key={route.path}
            exact
            path={route.path}
            render={(props: RouteComponentProps) => {
              const Cmp = route.component as React.ComponentType<RouteComponentProps>;
              return <Cmp {...props} />;
            }}
          />
        ))}

        {smsInstantRedirectConfig.map((el) => {
          return (
            <Route
              key={el.name}
              exact
              path={`/${el.name}`}
              render={(props) => (
                <DCBSms {...props} name={el.name} shortCode={el.shortCode} body={el.body} />
              )}
            />
          );
        })}

        {['/b2b', '/b2b/:lang'].map((path) => (
          <Route exact key={path} path={path} render={() => <MainB2BLayout />} />
        ))}

        <RoutesConfigurations />

        <Route component={NotFound} />
      </Switch>
    </section>
  );
};

export default Routes;
